import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, LifeBuoy } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const GraceTestCard = ({ onSent }) => {
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/admin/jobs/grace-nudges/test`);
      toast[r.data.email_ok ? "success" : "message"](r.data.email_ok ? `Test copy sent to ${r.data.to}.` : `The provider didn't accept it (to ${r.data.to}) — see the log below.`);
      onSent?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not send the test copy.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="tacc-card p-5 md:p-6 flex flex-col md:flex-row md:items-center justify-between gap-4" data-testid="grace-test-card">
      <div>
        <div className="section-tag mb-2 flex items-center gap-2"><LifeBuoy size={12} /> Grace-day email</div>
        <div className="font-display text-xl md:text-2xl tracking-tight leading-tight">"Your streak is one tap from safe."</div>
        <p className="text-[#78716C] text-sm mt-2 max-w-xl">Goes out automatically at 8:30am ET, only to members who missed exactly yesterday with a 3+ day streak and a grace day left. This button sends one [TEST] copy to your inbox — nobody else.</p>
      </div>
      <button onClick={send} disabled={busy} className="btn-outline text-xs whitespace-nowrap disabled:opacity-50" data-testid="grace-test-btn">
        <Mail size={13} /> {busy ? "Sending…" : "Send me a test copy"}
      </button>
    </div>
  );
};
